import React from 'react';
import {FiltersDropdownComp} from './FiltersDropdown';

export const dropdownRef: React.RefObject<FiltersDropdownComp> = React.createRef();
